/**
 * The product's user-visible name.
 *
 * Deliberately separate from the internal package scope (`@re-platform/*`), the
 * repo name, and the Pages project — those are engineering identifiers no client
 * ever sees, and renaming them would churn every import for no user benefit.
 * This constant is the single source for the name that DOES appear on screen.
 */
export const APP_NAME = "My Home Journey";

/**
 * Where a client is told to write when something goes wrong.
 *
 * `info@`, not `support@`: this mailbox actually exists and is a verified
 * Postmark sender. A support address that bounces is worse than none — the
 * client has already hit a problem by the time they read it.
 */
export const SUPPORT_EMAIL = "info@newbrain.us";
